import React from 'react'
import customWeb from '../../Image/Service/Custom-Web.svg'
import webPortal from '../../Image/Service/Web-Portal.svg'
import eCommerce from '../../Image/Service/E-Commerce.svg'
import mobileFriendly from '../../Image/Service/Mobile-Friendly.svg'
import Maintanance from '../../Image/Service/Maintanance.svg'
import openSorce from '../../Image/Service/Open-Sorce.svg'
import crossArrow from '../../Image/Service/Cross-Arrow.svg'

import android from '../../Image/Mobile/Android.svg'
import iphone from '../../Image/Mobile/Iphone.svg'
import hybrid from '../../Image/Mobile/Hybrid.svg'
import crossPlatform from '../../Image/Mobile/Cross-Platform.svg'
import enterpriseMobility from '../../Image/Mobile/Enterprise-Mobility.svg'
import wearable from '../../Image/Mobile/WeArable.svg'

import research from '../../Image/Seo/Research.svg'
import linkBuilding from '../../Image/Seo/Link-Building.svg'
import technicalSeo from '../../Image/Seo/Technical-Seo.svg'
import ecommerce from '../../Image/Seo/E-commerce.svg'
import contentWriting from '../../Image/Seo/Content-Writing.svg'
import conversionRate from '../../Image/Seo/Conversion-Rate.svg'

import seo from '../../Image/DigitalMarketing/Seo.svg'
import contentStrategies from '../../Image/DigitalMarketing/Content-Strategies.svg'
import socialMedia from '../../Image/DigitalMarketing/Social-Media.svg'
import emailMarketing from '../../Image/DigitalMarketing/Email-Marketing.svg'
import businessMarketing from '../../Image/DigitalMarketing/Business-Marketing.svg'
import dataAnalytics from '../../Image/DigitalMarketing/Data-Analytics.svg'


import Wave from 'react-wavify'
import { useParams } from 'react-router-dom'

const WebService = () => {
  const { category } = useParams();


  const head = {
    web: {
      title: "WEB APPLICATION DEVELOPMENT SERVICES",
      des: (
        <>
          <span className="text-purple-600 font-semibold">Kalathiya Infotech</span> LLP is a renowned website development service company catering to various industries with our bespoke website development services.
        </>
      )
    },
    mobile: {
      title: "MOBILE APPLICATION DEVELOPMENT SERVICES",
      des: (
        <>
          <span className='text-purple-600 font-semibold'>The Kalathiya Infotech</span> is a renowned website development service company catering to various industries with our bespoke website development services.
        </>
      )
    },
    seo: {
      title: "WEB APPLICATION DEVELOPMENT SERVICES",
      des: (
        <>
          <span className='text-purple-600 font-semibold'>Kalathiya Infotech</span> LLP is a renowned website development service company catering to various industries with our bespoke website development services.
        </>
      )
    },
    fullStack: {
      title: "WEB APPLICATION DEVELOPMENT SERVICES",
      des: (
        <>
          <span className='text-purple-600 font-semibold'>Kalathiya Infotech</span> is a highly esteemed provider of website development services, serving diverse industries with our tailored and personalized approach.
        </>
      )
    },
    digitalMarketing: {
      title: "DIGITAL MARKETING SERVICES",
      des: ( <><span className='text-purple-600 font-semibold'>Kalathiya Infotech</span> a distinguished name in digital marketing, tailors strategic campaigns that propel businesses across diverse industries to online success through customized solutions.</>)
    },
    reactNative: {
      title: "WEB APPLICATION DEVELOPMENT SERVICES",
      des: (
        <>
          <span className='text-purple-600 font-semibold'>Kalathiya Infotech</span> is a highly esteemed provider of website development services, serving diverse industries with our tailored and personalized approach.
        </>
      )
    }
  }

  const webService = {
    web: [
      {
        icon: customWeb,
        crossArrow: crossArrow,
        title: "Custom Web Development",
        desc: "We offer customized and quality website development services for your business. Hire the top custom web development company cost-effectively.",
      },
      {
        icon: webPortal,
        crossArrow: crossArrow,
        title: "Web Portal Development",
        desc: "Our wide range of web portal development services helps you get the complete chain of business verticals using versatile development experience.",
      },
      {
        icon: eCommerce,
        crossArrow: crossArrow,
        title: "E-commerce Development",
        desc: "We will provide intellectual resolution for your business as we have delivered a complete business project of the E-commerce platform for B2B and B2C businesses.",
      },
      {
        icon: openSorce,
        crossArrow: crossArrow,
        title: "Web Open Source Integration and Customization",
        desc: "We offer customized and quality website development services for your business. Hire the top custom web development company cost-effectively.",
      },
      {
        icon: mobileFriendly,
        crossArrow: crossArrow,
        title: "Mobile-Friendly Website Development",
        desc: "Our team develops a compelling mobile presence solution that is easily accessible on all handsets or devices. web applications from our experienced resources.",
      },
      {
        icon: Maintanance,
        crossArrow: crossArrow,
        title: "Flexible Web Maintenance Custom Web Development",
        desc: "Find our post-development support and accessible web maintenance services to keep your website updated and function hassle-free.",
      },
    ],
    mobile: [
      {
        icon: android,
        crossArrow: crossArrow,
        title: "Android App Development",
        desc: "Our Android App Developers aim to develop the best Android applications with robust code, user-friendly interface, and seamless UX.",
      },
      {
        icon: iphone,
        crossArrow: crossArrow,
        title: "iPhone App Development",
        desc: "Our iPhone App development methodology functions with a mission to boost your business for future growth to sustain in the digital area.",
      },
      {
        icon: hybrid,
        crossArrow: crossArrow,
        title: "Hybrid App Development",
        desc: "We deliver hybrid apps that engage users, provide them with justified benefits and leave an impactful impression on their minds.",
      },
      {
        icon: crossPlatform,
        crossArrow: crossArrow,
        title: "Cross-platform Mobile App Development",
        desc: "We use Cross-platform projects such as Appcelerator, Cordova (PhoneGap), and dozens of other tools to facilitate the mobile development process.",
      },
      {
        icon: enterpriseMobility,
        crossArrow: crossArrow,
        title: "Enterprise Mobility Solutions",
        desc: "We provide Enterprise Mobility Solutions that help your enterprise multiply. It controls and monitors data securely and authentically.",
      },
      {
        icon: wearable,
        crossArrow: crossArrow,
        title: "We arable App Development",
        desc: "We build customized and custom-centric applications that run seamlessly on wearable devices like smartwatches and smart-band machines.",
      },

    ],
    seo: [
      {
        icon: research,
        crossArrow: crossArrow,
        title: "Keyword Research & Strategy",
        desc: "Keyword research is indeed the foundation of effective SEO (Search Engine Optimization). It involves the process of identifying and analyzing the specific words and phrases that people use when searching for information online.",
      },
      {
        icon: linkBuilding,
        crossArrow: crossArrow,
        title: "Link Building",
        desc: "Link building is a basic aspect of search engine optimization (SEO). It involves the process of acquiring high-quality backlinks from other reputable websites to improve your own site’s authority, trustworthiness, and visibility in search engine results pages (SERPs).",
      },
      {
        icon: technicalSeo,
        crossArrow: crossArrow,
        title: "Technical SEO",
        desc: "This aspect focuses on the technical elements of a website, ensuring that it’s structured and coded in a way that search engines can easily crawl and index. This includes optimizing site speed, and mobile-friendliness, and fixing crawl errors.",
      },
      {
        icon: ecommerce,
        crossArrow: crossArrow,
        title: "E-Commerce SEO",
        desc: "E-commerce SEO, also known as online store SEO (Search engine optimization) or retail SEO, is a specialized part of search engine optimization that is tailored to e-commerce websites. It focuses on optimizing various aspects of an online store to improve its visibility in search engine results and drive organic traffic.",
      },
      {
        icon: contentWriting,
        crossArrow: crossArrow,
        title: "Content Writing",
        desc: "Content writing is the skill & art of crafting well-crafted, valuable, and captivating content with the aim of satisfying the needs and interests of both search engines and human audiences. It plays a crucial role in search engine Optimization and digital marketing, online communication, and information dissemination.",
      },
      {
        icon: conversionRate,
        crossArrow: crossArrow,
        title: "Conversion Rate Optimization",
        desc: "Conversion Rate Optimization (CRO) is indeed a critical aspect of digital marketing that aims to enhance the percentage of website visitors who complete specific desired actions or conversions. These actions can vary depending on the goals of a website or online platform, such as making a purchase, signing up for a newsletter, or filling out a contact form.",
      },

    ],
    fullStack: [
      {
        icon: customWeb,
        crossArrow: crossArrow,
        title: "Custom Web Development",
        desc: "Full Stack involves the creation of tailor-made web applications that meet the unique requirements and objectives of businesses or individuals.",
      },
      {
        icon: webPortal,
        crossArrow: crossArrow,
        title: "Web Portal Development",
        desc: "Our team of seasoned professionals is adept at leveraging open-source solutions to deliver tailored web development services that align with your unique objectives.",
      },
      {
        icon: eCommerce,
        crossArrow: crossArrow,
        title: "E-commerce Development",
        desc: "Hey contribute to various stages of the development process, including design, backend development, payment gateway integration, and maintenance.",
      },
      {
        icon: mobileFriendly,
        crossArrow: crossArrow,
        title: "Web Open Source Integration and Customization",
        desc: "Full stack development refers to the development process of web application components on the client side (front-end) and on the server side (back-end).",
      },
      {
        icon: Maintanance,
        crossArrow: crossArrow,
        title: "Mobile-Friendly Website Development",
        desc: "Our team develops a compelling mobile presence solution that is easily accessible on all handsets or devices. web applications from our experienced resources.",
      },
      {
        icon: openSorce,
        crossArrow: crossArrow,
        title: "Flexible Web Maintenance Custom Web Development",
        desc: "Our team is committed to ensuring the ongoing flexibility and reliability of your web presence, while also delivering customized solutions that precisely meet your unique requirements.",
      },
    ],
    digitalMarketing: [
      {
        icon: seo,
        crossArrow: crossArrow,
        title: "SEO Essentials",
        desc: "SEO Essentials covers the fundamental principles of Search Engine Optimization, focusing on techniques to improve a website’s visibility in search engine results.",
      },
      {
        icon: contentStrategies,
        crossArrow: crossArrow,
        title: "Content Strategies",
        desc: "Content Strategies delve into the planning and creation of compelling and valuable content. It encompasses content marketing, storytelling & driving organic traffic.",
      },
      {
        icon: socialMedia,
        crossArrow: crossArrow,
        title: "Social Media Trends",
        desc: "Social Media Trends explores the latest developments. It discusses advertising techniques, & strategies for the power of social media brand promotion & audience engagement.",
      },
      {
        icon: emailMarketing,
        crossArrow: crossArrow,
        title: "Email Marketing Tips",
        desc: "Email Marketing Tips provide insights into crafting effective email campaigns. email design, automation, & practices for delivering engaging & conversion-focused email content.",
      },
      {
        icon: businessMarketing,
        crossArrow: crossArrow,
        title: "Business Marketing",
        desc: "Business Marketing delves into marketing strategies tailored for businesses, covering B2B (business-to-business) & B2C (business-to-consumer) marketing approaches.",
      },
      {
        icon: dataAnalytics,
        crossArrow: crossArrow,
        title: "Data Analytics Insights",
        desc: "Data analytics insights play a crucial role in modern marketing, exploring data-driven decision-making in marketing. It includes discussions on tools & techniques for collecting, analyzing, and interpreting data.",
      },
    ],
    reactNative: [
      {
        icon: customWeb,
        crossArrow: crossArrow,
        title: "Custom Web Development",
        desc: "Full Stack involves the creation of tailor-made web applications that meet the unique requirements and objectives of businesses or individuals.",
      },
      {
        icon: webPortal,
        crossArrow: crossArrow,
        title: "Web Portal Development",
        desc: "Our team of seasoned professionals is adept at leveraging open-source solutions to deliver tailored web development services that align with your unique objectives.",
      },
      {
        icon: eCommerce,
        crossArrow: crossArrow,
        title: "E-commerce Development",
        desc: "Hey contribute to various stages of the development process, including design, backend development, payment gateway integration, and maintenance.",
      },
      {
        icon: openSorce,
        crossArrow: crossArrow,
        title: "Flexible Web Maintenance Custom Web Development",
        desc: "Our team is committed to ensuring the ongoing flexibility and reliability of your web presence, while also delivering customized solutions that precisely meet your unique requirements.",
      },
      {
        icon: mobileFriendly,
        crossArrow: crossArrow,
        title: "Web Open Source Integration and Customization",
        desc: "Full stack development refers to the development process of web application components on the client side (front-end) and on the server side (back-end).",
      },
      {
        icon: Maintanance,
        crossArrow: crossArrow,
        title: "Mobile-Friendly Website Development",
        desc: "Our team develops a compelling mobile presence solution that is easily accessible on all handsets or devices. web applications from our experienced resources.",
      },

    ]
  };
  if (category === "design" || category === "responsiveDesign") {
    return null;
  }
  return (
    <>
      <div className='overflow-hidden'>
        <Wave fill='#F6F6F6' paused={false} style={{ display: 'flex' }} options={{ height: 20, amplitude: 20, speed: 0.3, points: 5 }} className='relative min-w-[1920px] h-[30px]' />
        <section className="bg-[#F6F6F6] sm:px-0 py-10 pb-0">
          <div className="container mx-auto">
            <h2 className="text-xl font-bold text-black mb-2">{head[category]?.title || ''}</h2>
            <p className="text-gray-700 text-sm mb-6">{head[category]?.des || ''}</p>
            <div className="flex flex-wrap">
              {webService[category]?.map((service, index) => {
                return (
                  <div className="w-full sm:w-1/2 lg:w-1/3 p-0 sm:px-3 mb-6">
                    <div className="p-6 bg-white rounded-2xl shadow-md border border-gray-100 hover:shadow-purple-md transition duration-300 ease-in-out relative h-full">
                      <div className="absolute top-4 right-4 bg-gradient-to-tr bg-[#F0E3FF] p-2 rounded-full"><img src={service?.crossArrow} alt="crossArrow" className="w-4 h-4" /></div>
                      <div className="mb-4"><img src={service?.icon} alt="Web Dev Icon" /></div>
                      <h3 className="text-lg font-bold text-black mb-2">{service?.title}</h3>
                      <p className="text-sm text-gray-600">{service?.desc}</p>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
          <Wave fill='#Fff' paused={false} style={{ display: 'flex' }} options={{ height: 20, amplitude: 20, speed: 0.3, points: 5 }} className='relative min-w-[1920px] h-[30px]' />
        </section>
      </div>

    </>
  )
}

export default WebService